import * as React from 'react';
import { Translate } from '../../../../../../shared/LanguageService';
import history from '../../../../../../shared/history';
import BaseTab from './BaseTab';

type StylistCalendarTabProps = {
    label: string;
};

const StylingCalendarRoute = '/stylingcalendar';

let routes = [StylingCalendarRoute];

function StylistCalendarTab({ label, ...props }: StylistCalendarTabProps) {
    function handleClick() {
        history.push(StylingCalendarRoute);
    }

    return <BaseTab {...props} onClick={handleClick} label={label} route={StylingCalendarRoute} />;
}

function TranslatedStylistCalendarTab(props) {
    const label = Translate('header/nav/calendar');
    return <StylistCalendarTab {...props} label={label} />;
}

TranslatedStylistCalendarTab.routes = routes;

export default TranslatedStylistCalendarTab;
